import { useState } from "react";

function BookCar() {
  const [carType, setCarType] = useState("");
  const [pickUp, setPickUp] = useState("");
  const [dropOff, setDropOff] = useState("");
  const [pickUpDate, setPickUpDate] = useState("");

  const formatDateForWhatsApp = (isoDate) => {
    if (!isoDate) return "Not specified";

    const dateObj = new Date(isoDate);

    if (isNaN(dateObj.getTime())) {
      return "Invalid date";
    }

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  };

  // open modal when all inputs are fulfilled
  const openModal = () => {
    const formattedPickUpDate = formatDateForWhatsApp(pickUpDate);

    // Check if all required fields are filled
    if (carType && pickUp && dropOff && pickUpDate) {
      const actionLink = `https://wa.me/918007722929?text=I%20want%20to%20book%20a%20${encodeURIComponent(
        carType
      )}%20from%20${encodeURIComponent(pickUp)}%20to%20${encodeURIComponent(
        dropOff
      )}%20on%20${encodeURIComponent(formattedPickUpDate)}`;
      window.open(actionLink, "_blank");
    } else {
      // Show which fields are missing
      const missingFields = [];
      if (!carType) missingFields.push("Car Type");
      if (!pickUp) missingFields.push("Pick-up Location");
      if (!dropOff) missingFields.push("Drop-off Location");
      if (!pickUpDate) missingFields.push("Pick-up Date");

      alert(
        `Please fill in the following required fields: ${missingFields.join(
          ", "
        )}`
      );
    }
  };

  // taking value of booking inputs
  const handleCar = (e) => {
    setCarType(e.target.value);
  };

  const handlePick = (e) => {
    setPickUp(e.target.value);
  };

  const handleDrop = (e) => {
    setDropOff(e.target.value);
  };

  // UPDATED HANDLER: Handle input for the pickup date only
  const handlePickUpDate = (e) => {
    setPickUpDate(e.target.value);
  };

  // hide message
  const hideMessage = () => {
    const doneMsg = document.querySelector(".booking-done");
    doneMsg.style.display = "none";
  };

  return (
    <>
      <section id="booking-section" className="book-section">
        <div className="container">
          <div className="book-content">
            <div className="book-content__box">
              <h2>Book a car</h2>

              <p className="error-message">
                All fields required! <i className="fa-solid fa-xmark"></i>
              </p>

              <p className="booking-done">
                Check your email to confirm an order.{" "}
                <i onClick={hideMessage} className="fa-solid fa-xmark"></i>
              </p>

              <form className="box-form">
                <div className="box-form__car-type">
                  <label>
                    <i className="fa-solid fa-car"></i> &nbsp; Select Your Car
                    Type <b>*</b>
                  </label>
                  <select value={carType} onChange={handleCar}>
                    <option>Select your car type</option>
                    <option value="Innova Crysta">Innova Crysta</option>
                    <option value="Toyota Rumion">Toyota Rumion</option>
                    <option value="Maruti Suzuki Ertiga">
                      Maruti Suzuki Ertiga
                    </option>
                    <option value="Maruti Suzuki Dzire">
                      Maruti Suzuki Dzire
                    </option>
                    <option value="Hyundai Aura">Hyundai Aura</option>
                    <option value="Maruti Suzuki Wagon R">
                      Maruti Suzuki Wagon R
                    </option>
                  </select>
                </div>

                {/* SIMPLIFIED DATE FIELD - Removed problematic classes */}
                <div className="box-form__car-time">
                  <label>
                    <i className="fa-regular fa-calendar-alt"></i> &nbsp;
                    Pick-up Date <b>*</b>
                  </label>
                  <input
                    value={pickUpDate}
                    onChange={handlePickUpDate}
                    type="date"
                    style={{
                      padding: "1.3rem 1.5rem",
                      border: "2px solid #e0e7f1",
                      borderRadius: "0.6rem",
                      fontSize: "1.5rem",
                      fontFamily: "inherit",
                      outline: "none",
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                  />
                </div>

                <div className="box-form__car-time">
                  <label>
                    <i className="fa-solid fa-location-dot"></i> &nbsp; Pick-up{" "}
                    <b>*</b>
                  </label>
                  <input
                    value={pickUp}
                    onChange={handlePick}
                    type="text"
                    placeholder="Enter pick up location"
                    style={{
                      padding: "1.3rem 1.5rem",
                      border: "2px solid #e0e7f1",
                      borderRadius: "0.6rem",
                      fontSize: "1.5rem",
                      fontFamily: "inherit",
                      outline: "none",
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                  />
                </div>

                <div className="box-form__car-time">
                  <label>
                    <i className="fa-solid fa-location-dot"></i> &nbsp; Drop-off{" "}
                    <b>*</b>
                  </label>
                  <input
                    value={dropOff}
                    onChange={handleDrop}
                    type="text"
                    placeholder="Enter drop off location"
                    style={{
                      padding: "1.3rem 1.5rem",
                      border: "2px solid #e0e7f1",
                      borderRadius: "0.6rem",
                      fontSize: "1.5rem",
                      fontFamily: "inherit",
                      outline: "none",
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                  />
                </div>

                <button
                  onClick={(e) => {
                    e.preventDefault();
                    openModal();
                  }}
                  type="button"
                  style={{
                    padding: "1.3rem 2rem",
                    border: "none",
                    fontFamily: "inherit",
                    fontSize: "1.8rem",
                    fontWeight: "500",
                    color: "white",
                    backgroundColor: "#ff4d30",
                    borderRadius: "0.6rem",
                    cursor: "pointer",
                    boxShadow: "0 10px 15px rgba(255, 83, 48, 0.35)",
                    transition: "all 0.3s",
                  }}
                >
                  Request Callback
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BookCar;
